export default __webpack_public_path__ + "static/media/Raj.24102d2b.jpg";